/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "client": {
            "nested": {
              "ClientInfo": {
                "fields": {
                  "userAgent": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deviceUuid": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "timestamp": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "dateFormat": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "timeFormat": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "ipAddress": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "deviceName": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "navigationParadigm": {
                    "type": "squareup.cash.client.ClientInfo.NavigationParadigm",
                    "id": 8,
                    "rule": "optional"
                  },
                  "acceptLanguage": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "clientScenario": {
                    "type": "int32",
                    "id": 10,
                    "rule": "optional"
                  },
                  "deviceInstallationId": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "drmId": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "NavigationParadigm": {
                    "values": {
                      "TRADITIONAL": 1,
                      "TABBAR": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.client?.nested?.ClientInfo && !$root.nested?.squareup?.nested?.cash?.nested?.client?.nested?.ClientInfo?.nested?.NavigationParadigm) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ClientInfo @ squareup/cash/client/client_info.proto at 10:1
 */
export const ClientInfo = $root.lookupType('squareup.cash.client.ClientInfo');
fixType(ClientInfo);
Builder.createAndAttachToType(ClientInfo);
/**
 * SOURCE NavigationParadigm @ squareup/cash/client/client_info.proto at 11:3
 */
ClientInfo.NavigationParadigm = $root.lookupEnum('squareup.cash.client.ClientInfo.NavigationParadigm').values;